import React, {Component} from 'react';
import {AreaChart, Area, Tooltip, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Legend} from 'recharts';

class AccumulatedOptimizationCategoriesGraph extends Component{

  constructor(props){
    super(props);
    this.state={data:this.props.data}
  }

  render(){
    return(
      <ResponsiveContainer>
        <AreaChart width={730} height={250} data={this.state.data}>
          <XAxis dataKey={"month"}/>
          <YAxis scale={'linear'}/>
          <Tooltip/>
          <CartesianGrid/>
          <Area name={"USO DE SUELO"} type={"monotone"} dataKey={"landUse"} stroke={"#c79b6e"} fillOpacity={1} fill={"#c79b6e"} stackId={1}/>
          <Area name={"M2 CONSTRUCCION"} type={"monotone"} dataKey={"construction"} stroke={"#777"} fillOpacity={1} fill={"#777"} stackId={1}/>
          <Area name={"M2 SUELO"} type={"monotone"} dataKey={"floor"} stroke={"#222"} fillOpacity={1} fill={"#222"} stackId={1}/>
        </AreaChart>
      </ResponsiveContainer>
    );
  }

}

export default AccumulatedOptimizationCategoriesGraph;



// WEBPACK FOOTER //
// ./src/charts/accumulatedOptimizationCategoriesGraph.js